const e=e=>e.replace(/([a-z])([A-Z])/g,"$1_$2").toLowerCase();export{e as camelCaseToSnakeCase};
//# sourceMappingURL=textUtils.js.map
